import { PaymentMethodTypes } from '@autopass-web/mochi-payment-module';

import { AppStorage } from '../../utils/storage';

export const isAppleSupportVersion = () => {
  const { userAgent } = window.navigator;
  const start = userAgent.indexOf('OS ');
  if (start === -1) return false;
  const result = userAgent
    .substr(start + 3, 6)
    .replace(/_/g, '.')
    .split('.');

  // 10.1 以前禁止 apple pay
  if (
    Number(result[0]) < 10 ||
    (Number(result[0]) === 10 && Number(result[1]) === 0)
  ) {
    return false;
  }
  return true;
};

export const isLineInAppWebView = () => {
  const { userAgent } = window.navigator;
  return userAgent.match('Line/[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}');
};

export const checkIsApplePaySupported = () => {
  return (
    isAppleSupportVersion() &&
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    !!window.ApplePaySession &&
    !isLineInAppWebView()
  );
};

type PaymentMethodStorageValue = { method: PaymentMethodTypes };

export const paymentMethodStorage = new AppStorage<
  Partial<PaymentMethodStorageValue>
>('mochi-payment::method', 'json', 'local');
